import API from "../../core/apiConfig";
import {
  downloadBlobResponse,
  handleBlobExportError,
} from "../../core/download";
import { normalizePaginatedResponse } from "../../core/response";
import type {
  AddAllocationCostPayload,
  AllocationEstimateCostPayload,
  ConfirmImportAllocationCostPayload,
  ExportAllocationCostParams,
  UpdateAllocationCostPayload,
} from "./types";

const getAllLocationEstimateCost = async (params: Record<string, unknown>) => {
  const response = await API.get("/admin/allocationCost/estimation", {
    params,
  }).then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(response, "page");
  }
};

const getAllLocationVehicleCost = async (params: Record<string, unknown>) => {
  const response = await API.get("/admin/allocationCost/vehicle", {
    params,
  }).then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(
      response,
      "page",
      (item: { _id?: string; vehicleId?: string }) =>
        item._id ?? item.vehicleId,
    );
  }
};

const putUpdateLocationEstimateCost = async (
  id: string,
  payload: AllocationEstimateCostPayload,
) => {
  const response = await API.put(
    `/admin/allocationCost/estimation/${id}`,
    payload,
  );
  return response.data;
};

const getExportAllLocationCost = async (params: ExportAllocationCostParams) => {
  try {
    const response = await API.get("/admin/allocationCost/export", {
      params,
      responseType: "blob",
      silent: true,
      silentLoading: true,
    });

    return downloadBlobResponse(
      response,
      `Phân bổ ${params.month}/${params.year}.xlsx`,
    );
  } catch (error: unknown) {
    await handleBlobExportError(error);
    throw error;
  }
};

const postPreCheckImportAllLocationCost = async (file: Blob) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await API.post(
    "/admin/allocationCost/import/pre-check",
    formData,
  ).then((res) => res.data);

  return response;
};

const postConfirmImportAllLocationCost = async (
  payload: ConfirmImportAllocationCostPayload,
) => {
  const response = await API.post(
    "/admin/allocationCost/import/confirm",
    payload,
  );
  return response.data;
};

const postAddAllocationCost = async (payload: AddAllocationCostPayload) => {
  const response = await API.post("/admin/allocationCost", payload);
  return response.data;
};

const putUpdateAllocationCost = async (
  id: string,
  payload: UpdateAllocationCostPayload,
) => {
  const response = await API.put(`/admin/allocationCost/${id}`, payload);
  return response.data;
};

export default {
  getAllLocationEstimateCost,
  putUpdateLocationEstimateCost,
  getAllLocationVehicleCost,
  getExportAllLocationCost,
  postConfirmImportAllLocationCost,
  postPreCheckImportAllLocationCost,
  postAddAllocationCost,
  putUpdateAllocationCost,
};
